import styled from 'styled-components';
import TreeView from '@mui/lab/TreeView';
import { alpha } from "@mui/material/styles";

export const StyledSelectTree = styled(TreeView)`
  ${({ theme }) => `
    .MuiTreeItem-root.Mui-selected>.MuiTreeItem-content .MuiTreeItem-label {
      background-color: transparent !important;
    }

    .MuiTreeItem-iconContainer {
      width: 0;
    }

    .tree-item-form-checkbox {
      width: 100%;
    }

    .tree-item-form-checkbox .tree-node {
      color: ${theme.uptimeColors.mainTheme.primary};
    }

    .parent-treee-item {
      margin-left: ${theme.uptimeSpace[12]}px;
    }

    .parent-treee-item .MuiTreeItem-label {
      padding-left: ${theme.uptimeSpace[5]}px;
    }

    .parent-treee-item .MuiTreeItem-label:hover {
      background-color: transparent;
    }

    .parent-treee-item .MuiTreeItem-group {
      margin-left: ${theme.uptimeSpace[3]}px;
      padding-left: ${theme.uptimeSpace[4]}px;
      border-left: 1px dashed ${alpha(theme.uptimeColors.grayScales.black, 0.4)};
    }

    .parent-treee-item .close {
      opacity: 0.3;
    }

    .parent-treee-item .parent-treee-item-label {
      display: block;
      float: left;
      padding: ${theme.uptimeSpace[3]}px 0;
    }

    .parent-treee-item .parent-treee-item-button {
      float: right;
      margin: ${theme.uptimeSpace[2]}px;
    }

  `}
`;